import http from "../http-common";



class SessionValidation {

  sessionValidate() {
    const formData = {
      "token":token
    };
    return http.post('/agent/validateSession', formData);
  }
}

export default new SessionValidation();